// The templates header and an in-flight client refresh can finish out of
// order. The newest whole-program open wins until the coach picks a tab,
// a client, or a block entry.
let programFetchEntry = "";

export function beginProgramFetch() {
  programFetchEntry = String(Date.now());
  return programFetchEntry;
}

export function clearProgramFetch() {
  programFetchEntry = "";
}

export function currentProgramFetch() {
  return programFetchEntry;
}
